import { render, staticRenderFns } from "./401.vue?vue&type=template&id=6b10a48b&scoped=true&"
var script = {}
import style0 from "./401.vue?vue&type=style&index=0&id=6b10a48b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10a48b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b10a48b')) {
      api.createRecord('6b10a48b', component.options)
    } else {
      api.reload('6b10a48b', component.options)
    }
    module.hot.accept("./401.vue?vue&type=template&id=6b10a48b&scoped=true&", function () {
      api.rerender('6b10a48b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/401.vue"
export default component.exports